import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=4a1d56da"
import script from "./CardModal.vue?vue&type=script&lang=js"
export * from "./CardModal.vue?vue&type=script&lang=js"
import style0 from "./CardModal.vue?vue&type=style&index=0&id=4a1d56da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports